<template>
  <div>
    <h5>Card Payment</h5>
    <div class="py-4 col-12 text-center align-center">
      Payment Service is provided by
      <a
        href="https://www.nets.eu/payments?hsa_ver=test"
        target="_new"
      >
        Nets
      </a>
      <br>
      <div
        class="dibs_brand_assets"
        style="margin: 20px;"
      >
        <img
          src="https://cdn.dibspayment.com/logo/checkout/combo/horiz/DIBS_checkout_kombo_horizontal_02.png"
          alt="DIBS - Payments made easy"
          width="420"
        >
      </div>
      <button
        class="btn btn-lg btn-primary"
        @click.prevent.stop="nets_payment"
      >
        <span class="icon-receipt mr-2 pl-2" />Continue to Nets Payment
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NetsPayment',
  components: {
  },
  props: {
    dibsAmount: { type: [String, Number], default: 0 },
    productName: { type: String, default: 'GDQ Report' },
    orderId: { type: [String, Number], default: 0 },
    acceptUrl: { type: String, default: '' },
    cancelUrl: { type: String, default: '' }
  },
  data () {
    return {
    }
  },
  methods: {
    nets_payment () {
      const data = {
        order: {
          items: [
            {
              reference: 'GDQR',
              name: this.productName,
              quantity: 1,
              unit: 'pcs',
              unitPrice: this.dibsAmount * 100 * 0.8,
              taxRate: 2500,
              taxAmount: this.dibsAmount * 100 * 0.20,
              netTotalAmount: this.dibsAmount * 100 * 0.8,
              grossTotalAmount: this.dibsAmount * 100
            }
          ],
          amount: this.dibsAmount * 100,
          currency: 'SEK',
          reference: this.orderId
        },
        checkout: {
          termsUrl: 'https://gdq.se/en/privacypolicy/',
          publicDevice: false,
          charge: true,
          integrationType: 'HostedPaymentPage',
          merchantHandlesConsumerData: true,
          consumerType: {
            supportedTypes: ['B2C'],
            default: 'B2C'
          },
          returnUrl: this.acceptUrl,
          cancelUrl: this.cancelUrl
        }
      }
      this.$store.dispatch('netspayment_create', data)
        .then((resp) => {
          const data = JSON.parse(resp.data.response)
          if (data.err !== '') {
            const paymentId = data.paymentId
            const invoice_id = this.orderId - 1000000
            const payload = { invoice_id, payment_method_id: 4, payment_id: paymentId }
            this.$store.dispatch('paymentlog_create', payload).then(() => {
              this.$store.dispatch('netspayment_set', { current_netspayment_id: paymentId })
                .then(() => {
                  const hostedPaymentPageUrl = data.hostedPaymentPageUrl
                  window.location = hostedPaymentPageUrl
                })
            })
          } else {
            alert('Could not create payment')
          }
        })
    }
  }
}
</script>
<style>
</style>
